import { useCheckFeatureFlag } from './useFeatureFlags';
import { FeatureFlags } from './useFeatureFlags/types';

function useIsNewTrainingUIEnabled() {
  const checkFeatureFlag = useCheckFeatureFlag();

  return checkFeatureFlag(FeatureFlags.ORG_TRAINING_2025_08_GA_UI);
}

export default useIsNewTrainingUIEnabled;
